var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"centered":"","show-arrows":"","slider-color":"secondary"}},_vm._l((_vm.routes),function(ref){
var path = ref.path;
var ref_meta = ref.meta;
var title = ref_meta.title;
var icon = ref_meta.icon;
return _c('v-tab',{key:path,attrs:{"to":_vm.isAdminMode ? ("/admin/" + path) : ("" + path),"nav":""}},[_vm._v(" "+_vm._s(title)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }